import { render, staticRenderFns } from "./RecentPost.vue?vue&type=template&id=65437e80&scoped=true"
import script from "./RecentPost.vue?vue&type=script&lang=js"
export * from "./RecentPost.vue?vue&type=script&lang=js"
import style0 from "./RecentPost.vue?vue&type=style&index=0&id=65437e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65437e80",
  null
  
)

export default component.exports